import React, { Component, Fragment } from 'react';
import "../../../index.css";
import { withTranslation } from 'react-i18next';
import * as constants from "../constants";
import FilterHelper from "../../../helpers/filterHelper"; 
import { SearchList } from "../Lists/searchList";
import axios from 'axios';
import Spinner from './../CircularSpinner';
import * as locales from "../../../i18n/locales";

var isMounted = false;

export class WorkOrderList  extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows : [],
            filterOptions : [],
            builderList : [],
            isLoading : false,
            isRowStyle : false,
            workSiteId: this.props.filterId
        }
    }

    componentWillUnmount() {
        isMounted = false;
        this.props.cancelPromises();
        
    }

    componentDidMount() {
        this.setFilter();
        this.loadRecords("","",1);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.workOrders !== this.props.workOrders) {
            this.setState({
                rows : this.props.workOrders,
            });
        }

        if (prevProps.filterId  !== this.props.filterId) {
            if (this.props.filterId !== undefined) {
                this.setState({
                    workSiteId : this.props.filterId,
                }, function() {
                    var data = FilterHelper.getfilterOptions(constants.worOrderFilter);
                    this.loadRecords("", data.sort,1);
                });
            }
        }

    }
    
    setFilter = () => {
        this.setState({
            idSave : this.props.idSave,
        });

        var options = [
            FilterHelper.createFilterOption("workOrderNumber", true, true, 2, constants.textAlign.left, true),
            FilterHelper.createFilterOption("internalDescription", true, false, 4, constants.textAlign.left, true),
            FilterHelper.createFilterOption("invoiceDescription", false, false, 3, constants.textAlign.left, true),
            FilterHelper.createFilterOption("startTime", true, false, 3, constants.textAlign.left, true),
            FilterHelper.createFilterOption("endTime", true, false, 3, constants.textAlign.left, true),
        ];

        var id = this.props.idSave !== undefined ? this.props.idSave : constants.worOrderFilter;
        
        var filterOptions = FilterHelper.setFilter( id, options, false);

        this.setState({
            filterOptions : filterOptions.filter,
            isRowStyle : filterOptions.isRowStyle
        })
    }

    showFilterFields = (row, rowFilter) => {
        const { i18n } = this.props;
        
        return (
            <Fragment>
                
                {rowFilter.id === "workOrderNumber" &&
                    row.workOrderNumber
                }
                {rowFilter.id === "internalDescription" &&
                    row.internalDescription
                }
                {rowFilter.id === "invoiceDescription" &&
                    row.invoiceDescription
                }
                {rowFilter.id === "startTime" &&
                    
                    new Intl.DateTimeFormat(i18n.language, locales.DateNotations[i18n.language])
                    .format(Date.parse(row.agreedInterval.startTime))
                }
                {rowFilter.id === "endTime" &&
                    new Intl.DateTimeFormat(i18n.language, locales.DateNotations[i18n.language])
                    .format(Date.parse(row.agreedInterval.endTime))
                }
            </Fragment>
        )
    }

    loadRecords = async (filter, sort, page) => {
        isMounted = true;

        this.props.cancelPromises();

        var isLoaded = false;
        if (!this.props.isArray) {

            
            if (!this.props.isLoading) {
                this.setState({
                    isLoading : true
                })
            }

            var data = FilterHelper.getfilterOptions(constants.worOrderFilter);
            this.setState({
                filterOptions : data.filter,
                isRowStyle: data.isRowStyle 
            })

            const cancelToken = axios.CancelToken.source();

            await this.props.cancellablePromise(
               this.props.actions.readWorkOrders(filter, data.sort, page, this.state.workSiteId, cancelToken.token), cancelToken
            )
            .then(() => {
                isLoaded = true;
            })
            .catch((error) => {
                if (error.message === constants.cancelHttpRequest || error.message === "[object Object]") {
                    isMounted = false;
                }
            })
            .finally(result =>{
                if (isMounted) {
                    this.setState({
                        isLoading : false
                    })
                }
            })
        }
        else {
            this.props.loadRecords(filter, sort);
        }

        return isLoaded;
    }
    
    handleDeleteRow = async (record) => {
        if (!this.props.isLoading) {
            this.setState({
                isLoading : true
            })
        }

        record.state = constants.Deleted;
        var data = {...record};

        if (this.props.isTesting) {
            this.setState({
                recordTest : data
            });
        }
      
        var isDeleted = false;
        await this.props.actions.updateWorkOrder(data)
        .then(() => {
            isDeleted = true;
        })
        .catch(() => {})
        .finally(() =>{
            this.setState({
                isLoading : false
            })
        })
        return isDeleted;
    }

    handleJsonFile = async () => {

    }

    render() {
        const { t } = this.props;
        return (
            <Fragment>
                {this.state.isLoadingMassive &&
                    <Spinner open={true}/>
                }
                <SearchList 
                    {...this.props}
                    rows={this.state.rows}
                    showFilterFields={this.showFilterFields}
                    filterOptions={this.state.filterOptions}
                    isRowStyle={this.state.isRowStyle}
                    handleDeleteRow={this.handleDeleteRow}
                    loadRecords={this.loadRecords}
                    handleJsonFile={this.handleJsonFile}
                    
                    backButton={this.props.backButton !== undefined ? this.props.backButton : false}
                    onlySelect={this.props.onlySelect !== undefined ? this.props.onlySelect :  false}
                    addButton={this.props.addButton !== undefined ? this.props.addButton : true}
                    deleteButton={this.props.deleteButton !== undefined ? this.props.deleteButton  : true}
                    editButton={this.props.editButton !== undefined ? this.props.editButton : true}
                    isToUp={this.props.isToUp !== undefined ? this.props.isToUp : true}
                    title={t(this.props.title !== undefined ? this.props.title : "WorkOrders")} 
                    pathBackFromAddEdit={this.props.pathBackFromAddEdit !== undefined ? this.props.pathBackFromAddEdit : "/workOrdersList/"}
                    pathAddEdit={this.props.pathAddEdit !== undefined ? this.props.pathAddEdit : "/workOrders/"}
                    isLoading={this.state.isLoading}
                    handleOneSelect={this.props.handleOneSelect}
                    handleSearchOneSelect={this.props.handleSearchOneSelect}
                    multiSelect={this.props.multiSelect}
                
                    isArray={this.props.isArray}
                    handleAdd={this.props.handleAdd}
                    refreshDetails={this.props.refreshDetails}
                    builderList={this.state.builderList}
                    idSave={this.props.idSave !== undefined ? this.props.idSave : constants.worOrderFilter  }
                    handleCloseProduct={this.props.handleCloseProduct}
                    history={this.props.history}
                    notExpanded={this.props.notExpanded}
                />
            </Fragment>    
        )
    };
}

export default withTranslation('common')(WorkOrderList);
